export enum EAccessType {
    MOBILE_CLINIC = 'mobile_clinic',
    MOBILE_LAB = 'mobile_lab',
    ADMIN_LAB = 'admin_lab',
    ADMIN_CLINIC = 'admin_clinic',
}

export enum EAclModule {
    ACCESS = 'access',
    ADDRESS = 'address',
    CHAT = 'chat',
    EMPLOYEE = 'employee',
    FINANCIAL_BILLING = 'financial_billing',
    FINANCIAL_CREDIT_CARD = 'financial_credit_card',
    ORDER = 'order',
    ORDER_APPROVAL = 'order_approval',
    ORDER_MEDIA = 'order_media',
    ORDER_RATING = 'order_rating',
    ORDER_TOTAL = 'order_total',
    PATIENT = 'patient',
}

export enum EAclFunction {
    LIST = 'list',
    CREATE = 'create',
    UPDATE = 'update',
    DELETE = 'delete',
    EXPORT = 'export',
}

export enum EAclOperator {
    OR = 'or',
    AND = 'and',
}
